import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
  table_type: string().oneOf(['expired', 'today', 'afterToday', 'empty', 'completed']).required(),
});

/**
 * MySpaceMyTasksCreateEvent
 *
 * - Evento emitido quando uma tarefa é criada e deve ser adicionada ao meu espaço.
 */
export class MySpaceMyTasksCreateEvent extends CreateCommand(
  RealtimeEventType.MySpaceMyTasksCreate,
  SCHEMA,
) {}
